import { render, staticRenderFns } from "./message_tier_access_denied.vue?vue&type=template&id=0211da8a"
import script from "./message_tier_access_denied.vue?vue&type=script&lang=js"
export * from "./message_tier_access_denied.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports